import { SmartAssistant, SmartAssistantType } from 'shared/interfaces/SmartAssistant';

export const canOpenSmartAssistantPlayground = (smartAssistant: SmartAssistant) => {
  if (smartAssistant.type === SmartAssistantType.PHONE) return false;

  // Shopify Agent rely on Shopify Store Resource to be set for default tools to work
  if (smartAssistant.type === SmartAssistantType.SHOPIFY) {
    return !!smartAssistant.shopifyStoreResource;
  }

  return true;
};
